import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IUser, UserRoleType } from '../interfaces/user';

export const useForbidAccess = (me: IUser | undefined, roles: UserRoleType[]) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!me) return;
    let isForbidden = false;
    for (const role of roles) {
      if (me.roles.includes(role)) {
        isForbidden = true;
        break;
      }
    }
    if (isForbidden) {
      navigate('/error/error-v1', { replace: true });
    }
  }, [me, roles, navigate]);
};
